import { render, staticRenderFns } from "./RenderChildrensReferences.vue?vue&type=template&id=e367f48e&"
import script from "./RenderChildrensReferences.vue?vue&type=script&lang=js&"
export * from "./RenderChildrensReferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e367f48e')) {
      api.createRecord('e367f48e', component.options)
    } else {
      api.reload('e367f48e', component.options)
    }
    module.hot.accept("./RenderChildrensReferences.vue?vue&type=template&id=e367f48e&", function () {
      api.rerender('e367f48e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/traceability/RenderChildrensReferences.vue"
export default component.exports